// ── Stable, unambiguous card identifiers (issue #27) ──
// Animators/PMOs reference a project or task verbally in meetings, so every
// card needs a short id that's always present, even before a project_code has
// been assigned (should not happen in practice — initializeDatabase backfills
// any project missing one — but the UI must never silently show nothing).

/** Project display code: the assigned project_code, or a numeric fallback. */
export function projectDisplayCode(project: { id: number; project_code?: string | null }): string {
  return project.project_code || `P-${project.id}`;
}

/** Task display code: a stable short id derived from the task's row id. */
export function taskDisplayCode(task: { id: number }): string {
  return `T-${task.id}`;
}
